import * as React from "react";
import { SVGProps } from "react";
const SvgConsumption = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 6c7.18 0 13 5.82 13 13 0 1.535-.266 3.033-.78 4.447a1 1 0 1 1-1.88-.684c.435-1.195.66-2.462.66-3.763 0-6.075-4.925-11-11-11S5 12.925 5 19c0 1.3.225 2.567.66 3.763a1 1 0 0 1-1.879.684A12.982 12.982 0 0 1 3 19C3 11.82 8.82 6 16 6Zm-4.504 5.207a1 1 0 0 1 1.174.127l.082.084 5.134 5.947a2.499 2.499 0 0 1-1.585 4.116 2.5 2.5 0 0 1-2.612-1.515l-.056-.146-2.582-7.42a.998.998 0 0 1 .445-1.193Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgConsumption;
